import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLandingPage as GetLandingPageQuery,
    GetLandingPageVariables as GetLandingPageQueryVariables,
} from 'nutshell-graphql-types';

import GET_LANDING_PAGE from '../queries/get-landing-page.graphql';

export const useGetLandingPage = (pageId: string) => {
    const {
        loading: isLoading,
        data,
        error,
    } = useQuery<GetLandingPageQuery, GetLandingPageQueryVariables>(GET_LANDING_PAGE, {
        variables: {pageId},
        fetchPolicy: 'cache-and-network',
    });

    const page = data ? data.page : null;

    return {
        page,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
